<template>
  <label :class="['checkbox-inline', 'i-checks', tableInline ? 'checkbox-table-inline' : 'pt-1']" ref="checkbox_label">
    <span style="position: relative;">
      <input type="checkbox" :value="setting" :checked="shouldBeChecked" v-bind:name="name" v-bind:class="{'is-invalid': hasError()}" /> {{label}}
    </span>
    <div class="form-invalid-feedback" v-show="hasError()">
      {{getError()}}
    </div>
    <span v-if="!hasError() && note" class="form-field-note">{{note}}</span>
  </label>
</template>

<style scoped>
label.checkbox-table-inline {
  margin: 0;
}
</style>

<script>
import formField from '@/mixins/formField'

export default {
  name: "FormCheckbox",
  model: {
    event: 'change'
  },
  mixins: [formField],
  props: {
    label: String,
    name: String,
    setting: {
      type: [String, Number],
      default: ""
    },
    value: Boolean,
    field: String,
    note: String,
    tableInline: Boolean
  },
  watch: {
    value: function(newVal, oldVal) {
      var elementId = this.$refs.checkbox_label
      $(elementId).iCheck(newVal ? 'check' : 'uncheck')

      // Default to false if null given
      if(newVal == null) {
        this.$nextTick(() => {
          this.$emit('change', false)
        })
      }
    }
  },
  mounted() {
    var self = this
    var elementId = this.$refs.checkbox_label

    $(elementId).iCheck({
        checkboxClass: 'icheckbox_square-green',
        radioClass: 'iradio_square-green',
        focusClass: 'hover'
    });

    // Note: iCheck prevents vue's onchange event handling
    $(elementId).on('ifChecked', function(event) {
      self.$emit('change', true)
    });
    $(elementId).on('ifUnchecked', function(event) {
      self.$emit('change', false)
    });
    $(elementId).on('ifClicked', function(event) {
      self.$emit('click', event)
    });
  },
  computed: {
    shouldBeChecked() {
      return this.value
    }
  },
  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    }
  }
};
</script>
